var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wework-steps-sync"},[_c('sync-set',{ref:"syncSet"}),_c('sync-save',{ref:"syncSave"}),_c('steps-bottom',{attrs:{"is-last-step":_vm.isLastStep,"btn-disabled":_vm.btnDisabled},on:{"btnClick":_vm.onBtnClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }